<template>

<app-page v-if="is.loaded">

    <app-inner :condensed="true">

        <div class="event-contact">
            <div class="event-contact-item" v-if="page.phone">
                <app-icon name="phone" /> <a :href="linkPhone">{{ page.phone }}</a>
            </div> 
            <div class="event-contact-item" v-if="page.website">
                <app-icon name="website" /> <a :href="linkWebsite" target="_blank">Visit website</a>
            </div> 
            <div class="event-contact-item" v-if="page.address">
                <app-icon name="map-marker" /> <a :href="linkAddress" target="_blank">{{ page.address }}</a>
            </div> 
        </div>

        <app-text v-html="page.content" />

    </app-inner>

</app-page>

</template>

<script>

import mixinPage from '@/mixin/page.js'

export default {

    mixins: [mixinPage],

    computed: {

        linkAddress: function() {

            return 'https://www.google.co.uk/maps/search/' + encodeURIComponent(this.page.address)
             
        },

        linkPhone: function() {

            return 'tel:' + this.page.phone.replace(' ', '')

        },

        linkWebsite: function() {

            return this.page.website

        }

    }

}

</script>

<style scoped>

.event-contact {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 20px;
}

.is-mobile .event-contact {
    flex-direction: column;
}

.event-contact-item {
    padding: 0px 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    text-transform: uppercase;
    line-height: 20px;
    color: var(--color-grey-dark);
}

.is-mobile .event-contact-item {
    margin-bottom: 10px;
}

.event-contact-item a {
    font-weight: 700;
}

.is-desktop .event-contact-item a:hover {
    color: var(--color-blue-light);
}

.event-contact-item >>> .icon {
    color: var(--color-blue-light);
    margin-right: 10px;
}

</style>
